import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6ea70141&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./index.vue?vue&type=style&index=0&id=6ea70141&prod&scoped=true&lang=css")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "6ea70141",
  null
  ,true
)

export default component.exports